import { CoBrandingTheme } from '@nakedplatform/business/@types/modules/co-branding/types';
import { Colors } from '@nakedplatform/ui';

import * as zendesk from 'modules/zendesk';

/**
 * Opens the Zendesk Web widget
 *
 */
export function getHelp() {
  if (window.zE) {
    window.zE('webWidget', 'open');
  }
}
/**
 * Loads and shows the ZenDesk widget
 *
 */
export function loadZendesk() {
  zendesk
    .loadScript()
    .then(() => {
      window.zESettings = {
        webWidget: {
          color: {
            launcher: Colors.grey,
            launcherText: Colors.black,
          },
        },
      };
      if (window.zE) {
        window.zE('webWidget', 'show');
      }
    })
    .catch(() => {
      console.error('Failed to load ZenDesk widget.');
    });
}
/** Applies the co-branding partner (or default) UI theme to web widget
 *
 * @param theme - the new theme
 */
export function styleZendesk(theme: CoBrandingTheme) {
  const themeColor = theme?.palette?.activeColor ?? Colors.green;

  if (window.zE) {
    window.zE('webWidget', 'updateSettings', {
      webWidget: {
        color: {
          theme: themeColor,
        },
      },
    });
  }
}
